"use client";

import {
  FeatureHighlight,
  PriceCalculatorSteps,
} from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { floorPlanDetail } from "../../../../public/images/logos";

const PriceCalculation = () => {
  const t = useTranslations("threeSixtyService");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <div className="flex flex-col">
          <FeatureHighlight
            src={floorPlanDetail}
            alt={"floor plan logo"}
            title={t("priceCalculation")}
            text={""}
          />
          <PriceCalculatorSteps />
        </div>
      </div>
    </div>
  );
};

export default PriceCalculation;
